var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreActionDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.94922,
  y: 19.1992,
  width: 18,
  height: 18,
  rx: 9,
  transform: "rotate(-90 1.94922 19.1992)",
  stroke: "#6B5CE8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.49684 11.1992C6.28964 11.1992 6.08709 11.1378 5.91481 11.0227C5.74253 10.9075 5.60826 10.7439 5.52896 10.5525C5.44967 10.3611 5.42893 10.1504 5.46935 9.94722C5.50977 9.744 5.60955 9.55733 5.75606 9.41082C5.90257 9.26431 6.08924 9.16453 6.29246 9.12411C6.49568 9.08369 6.70632 9.10443 6.89774 9.18372C7.08917 9.26302 7.25279 9.39729 7.3679 9.56957C7.48302 9.74185 7.54446 9.9444 7.54446 10.1516C7.54446 10.4294 7.43408 10.6959 7.23762 10.8924C7.04115 11.0888 6.77468 11.1992 6.49684 11.1992ZM9.9016 10.1516C9.9016 10.3588 9.96304 10.5613 10.0782 10.7336C10.1933 10.9059 10.3569 11.0402 10.5483 11.1195C10.7397 11.1988 10.9504 11.2195 11.1536 11.1791C11.3568 11.1387 11.5435 11.0389 11.69 10.8924C11.8365 10.7459 11.9363 10.5592 11.9767 10.356C12.0171 10.1528 11.9964 9.94212 11.9171 9.75069C11.8378 9.55926 11.7035 9.39565 11.5312 9.28054C11.359 9.16542 11.1564 9.10398 10.9492 9.10398C10.6714 9.10398 10.4049 9.21435 10.2084 9.41082C10.012 9.60729 9.9016 9.87375 9.9016 10.1516ZM14.354 10.1516C14.354 10.3588 14.4154 10.5613 14.5305 10.7336C14.6456 10.9059 14.8093 11.0402 15.0007 11.1195C15.1921 11.1988 15.4028 11.2195 15.606 11.1791C15.8092 11.1387 15.9959 11.0389 16.1424 10.8924C16.2889 10.7459 16.3887 10.5592 16.4291 10.356C16.4695 10.1528 16.4488 9.94212 16.3695 9.75069C16.2902 9.55926 16.1559 9.39565 15.9836 9.28054C15.8113 9.16542 15.6088 9.10398 15.4016 9.10398C15.1238 9.10398 14.8573 9.21435 14.6608 9.41082C14.4644 9.60729 14.354 9.87375 14.354 10.1516Z",
  fill: "#6B5CE8"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreActionDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moreActionDisabled.9d3e6c2855694577272eb7a2672b2bb8.svg";